import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import { connect } from 'react-redux'
import {socketManager } from '../../actions'
import io from 'socket.io-client'
const socketUrl = "https://silver-house.ir";
class Header extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            socket:null,
            toggle:false
         }
    }
    componentDidMount(){
        this.initSocket();  
        this.setState({socket:socketManager()})
         
    }
    initSocket = () => {
        const socket = io(socketUrl);
        socket.on('connect'
        , (res) => {
        })
        
        this.props.dispatch(socketManager(socket)); 
    }
    componentWillReceiveProps(nextProps) {
     this.setState({toggle:nextProps.open})
    }
    handleToggle=() =>{
        this.setState({
            toggle : !this.state.toggle
        })
        this.props.toggleMenu()
    }
    render() { 
        const { toggle } = this.state;
        return (
            <AppBar position="static">
                <Toolbar>
                <div className={`hamburger hamburger--collapse ${toggle ? "is-active":""}`} onClick={this.handleToggle}>
                    <div className="hamburger-box">
                    <div className="hamburger-inner"></div>
                    </div>
                </div>
                    <Typography variant="h6" className="titleBar-txt">
                        خانه نقره
                    </Typography>

                </Toolbar>
            </AppBar>
          );
    }
}

export default connect()(Header);